import * as am5 from '@amcharts/amcharts5';
import { ElementRef } from '@angular/core';
import { Ratio } from '../../models';
import { createGraph } from './graph-utils';

const styles = {
    fill: am5.color('#BA61EB'),
    fillDark: am5.color('#6E0AD4'),
};

export function render(container: ElementRef, ratios: Ratio[]) {
    if (!container) return;

    createGraph(ratios, container, styles);
}
